import React, {useState, useRef, useEffect} from 'react'
import axios from "axios";
import {APIURL} from "../../Global";
import {Modal} from 'react-bootstrap';
import {Button} from 'react-bootstrap';
import { useAlert } from "react-alert";
function AddTemp(props) {
  const alert = useAlert();
    const [temp, setTemp]=useState()
    const saveButtonRef = useRef(null)

    useEffect(() => {
      const handleKey = (e) => {
  
        if (e.altKey && e.key === 's') {
          e.preventDefault()
          saveButtonRef.current.click()
        }else if (e.key === 'Enter') {
          e.preventDefault()
          saveButtonRef.current.click()
        }
      
      }
      document.addEventListener("keydown", handleKey);
      
      return () => {
        document.removeEventListener("keydown", handleKey);
      }
      
    }, []);
   
    const timezoneOffset = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const currentDateTime = toISOString(Date().toLocaleString());
  function toISOString(s) {
    var months = {jan:'01',feb:'02',mar:'03',apr:'04',may:'05',jun:'06',
                  jul:'07',aug:'08',sep:'09',oct:'10',nov:'11',dec:'12'};
    var b = s.split(' ');
  
    return b[3] + '-' +
           months[b[1].toLowerCase()] + '-' +
           ('0' + b[2]).slice(-2) + 'T' +
           b[4] + b[5].substr(3);
  }

    const handleChange = (e)=> {
        const val = e.target.value
        if(val.length < 6){
            setTemp(e.target.value)
        }
        else {
            return false
        }
    }

    const handleSubmit = () => {

        if(temp > 24.9 && temp < 50.1) {

            const id =props.id
        const tokenString= sessionStorage.getItem('usertoken');
   
        let str= tokenString.replace(/["]+/g, '');
         
         
       const dataToUpdate = 
           {
               'vital_name':"temperature",
               'result' :temp,
               'date_time':currentDateTime
           }
     
     
       
         axios.post(`${APIURL}/api/v1/patient/vitals/?patient_id=${id}&timeZone=${timezoneOffset}`,dataToUpdate, { headers: {
           
           "Authorization" : 'Token '+str,
           'Content-Type': 'application/json'  }
     
     
         })
     
     
     
         .then(res=>{
        
           if(res.data.status==="success"){
                alert.success("Temperature added Successfully")
                props.submittemp() ;setTemp("")
          
       }
       else{
            alert.error(res.data.message)
        
       }
     
         })
         

        }
        else {
            alert.error("Temperature value must be between 25 and 50 degree celsius")
        }

        
    }

  

    return (
        <div className='flex-col'>
           <input style={{width:'50%'}} type="number" min='0' max='45' placeholder="Add Temperature in Celsius" value={temp} onChange={handleChange} className="form-control"/><br/>
           <button disabled={temp<1 || temp=== undefined} onClick={handleSubmit} ref={saveButtonRef} className='btn btn-primary btn-col'>Add</button> 

        </div>
    )
}

export default AddTemp
